export default {
      id: "pay_sbp-usage",
      viewBox: "0 0 42 24",
      url: __webpack_public_path__ + "sprite.svg#pay_sbp",
      toString: function () {
        return this.url;
      }
    }